import { useEffect, useRef, useState } from "react";
import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { authService } from "../Services/authServices/requests.ts";
import { CustomLoading } from "../Components/index.js";
import 'react-toastify/dist/ReactToastify.css';

function Routes(){
    const isLogged = useSelector(state => state.userReducer.isLogged);
    const initialized = useRef(false);
    const [isInitializingAuth, setIsInitializingAuth] = useState(!isLogged);
    useEffect(() => {
        if (initialized.current) return;
        initialized.current = true;

        async function checkAuthentication() {
            try {
                await authService.refreshLogin();
            } catch (error) {
                console.log("Error refreshing login:", error);
            } finally {
                setIsInitializingAuth(false);
            }
        }

        if (!isLogged) {
            checkAuthentication();
        }
    }, []);

    if (isInitializingAuth) {
        return <CustomLoading width="300px" height="300px" />;
    }

    if(isLogged){
        return(<AppRoutes/>);
    }else{
        return(<AuthRoutes/>);
    }
}
export default Routes;